import PropTypes from 'prop-types'
import Validation from '../../wizard/Validation.jsx'
import InputNumeric from '../InputNumeric.jsx'

const InputWiz = (props) => {
    const dataFieldText =
        props.keyName.substring(props.keyName.lastIndexOf('.') + 1) ||
        props.keyName
    const labelFieldText = props.keyName
        .split('.')
        .map((t) => parseInt(t) || t)
        .filter((i) => isNaN(i))
        .join('.')

    const form = props.name ? props.wiz.form?.[props.name] : props.wiz.form
    const value = props.value
        ? props.value
        : props.row
        ? props.row?.[dataFieldText]
        : form?.[dataFieldText]
    const setter = props.setRow ? props.setRow : props.wiz.setValue

    return (
        <Validation wiz={props.wiz} field={props.keyName}>
            <InputNumeric
                decimal={props.decimal}
                label={props.label || props.wiz.getLabel(labelFieldText)}
                tooltipText={props.wiz.getToolTip(
                    props.keyName || labelFieldText || dataFieldText
                )}
                onChange={(e) => setter(dataFieldText, e.target.value)}
                value={value || ''}
                readOnly={props.readOnly}
                labelClassName={props.labelClassName}
                size={props.size}
                placeholder={props.placeholder}
                disabled={props.disabled}
                data-testid={props.dataTestId}
                id={props.id || props.name || props.ariaLabel}
                title={props.title || props.wiz.getLabel(labelFieldText)}
                className={props.className}
                limit={props.limit || props.wiz.getMax(dataFieldText)}
                showLimitter={props.showLimitter}
                onlyNumbers={props.onlyNumbers}
                limitterFloat={props.limitterFloat}
                type={'input'}
                errorText={props.errorText}
            />
        </Validation>
    )
}

InputWiz.propTypes = {
    regex: PropTypes.any,
    wiz: PropTypes.any.isRequired,
    keyName: PropTypes.string.isRequired,
    name: PropTypes.string,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    size: PropTypes.string,
    showLimitter: PropTypes.bool,
    onlyNumbers: PropTypes.bool,
    limitterFloat: PropTypes.oneOf(['end', 'start']),
    className: PropTypes.string,
    readOnly: PropTypes.bool,
    hideLabel: PropTypes.bool,
    label: PropTypes.string,
    noLabel: PropTypes.bool,
    id: PropTypes.string,
    fallbackValue: PropTypes.string,
    title: PropTypes.string,
    dataTestId: PropTypes.string,
    limit: PropTypes.number,
    value: PropTypes.any,
    setRow: PropTypes.func,
    row: PropTypes.object,
    labelClassName: PropTypes.string,
    ariaLabel: PropTypes.string,
    decimal: PropTypes.number,
    errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
}

export default InputWiz
